import useQuery from "utils/hooks/useQuery";
import { useEffect } from "react";
import { ExternalAccountType } from "@shared/types";
import localStorageService from "utils/localStorageService";
import { CONNECT_TELEGRAM_KEY } from "@shared/features/onboarding/constants";
import { useIsOnboarding } from "utils/hooks/misc";
import { useUser } from "@shared/utils/hooks/misc";
import useHistoryWithQuery from "utils/hooks/useHistoryWithQuery";

const useConnectTelegram = (
  externalAccountType?: ExternalAccountType | undefined,
  setExternalAccountType?: (externalAccountType: ExternalAccountType) => void,
  setExternalAccountModalVisible?: (
    externalAccountModalVisible: boolean
  ) => void
) => {
  const { user } = useUser();
  const isOnboarding = useIsOnboarding();
  const { appendQuery } = useHistoryWithQuery();

  const query = useQuery();
  const queryUuid = atob(query.get(user ? "short_uuid" : "uuid") || "");
  const queryCode = atob(query.get("sec_code") || "");
  const isTelegramConnected = user?.is_telegram_connected;

  useEffect(() => {
    localStorageService.removeValue(CONNECT_TELEGRAM_KEY);
  }, []);

  useEffect(() => {
    if (
      !!externalAccountType &&
      ((externalAccountType === ExternalAccountType.DISCORD &&
        !user?.is_discord_connected) ||
        (externalAccountType === ExternalAccountType.TELEGRAM &&
          !isTelegramConnected))
    ) {
      setExternalAccountModalVisible?.(true);
    }
  }, [externalAccountType]);

  useEffect(() => {
    if (queryUuid?.length || queryCode?.length) {
      if (!isTelegramConnected) {
        setExternalAccountType?.(ExternalAccountType.TELEGRAM);
        setExternalAccountModalVisible?.(true);
      } else {
        appendQuery(undefined, ["short_uuid", "sec_code"]);
      }
    }
  }, [queryCode, queryUuid]);

  const setLocalStorageKey = () => {
    const value = { pathname: location.pathname, search: location.search };
    if (!isOnboarding)
      localStorageService.setValue(CONNECT_TELEGRAM_KEY, JSON.stringify(value));
  };

  return { queryCode, queryUuid, setLocalStorageKey };
};

export default useConnectTelegram;
